// extracted by mini-css-extract-plugin
export default {"tooltip":"YJdIdRMHosf6rO0IY_IB","dismiss":"isG2Blv14ECFt8z9SbsS"};